module.exports = __webpack_public_path__ + "img/yoga-old.a48714f2.png";